import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from "vue";
import "@/plugins/Translation";
import useTranslations from "@/composables/useTranslations";
import ElErrorLandingPage from "@/components/El/ErrorLandingPage/ElErrorLandingPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebComponentErrorBlockedCode',
  props: {
    _language: { default: "" }
  },
  setup(__props: any) {

const props = __props as { _language: string }



const { $t, validate } = useTranslations();
// REQUIRED: Validate language prop
validate(props._language);

const returnBodyDescription = computed(() =>
  $t(
    `Sorry, it’s not possible to scan this QR Code at the moment. If you’re the owner of this QR Code, please <a href="https://login.qr-code-generator.com/" target="_blank" class="underline hover:text-primary/primary">log in</a> to reactivate it.`
  )
);

return { __sfc: true,props, $t, validate, returnBodyDescription, ElErrorLandingPage }
}

})